import axios from "@/axios";

export default {
    feature: {
        list() {
            return axios.get('home/features');
        }
    },
    advantage: {
        list(type) {
            return axios.get('home/advantages', {
                type: type
            });
        }
    },
    portfolio: {
        list() {
            return axios.get('home/portfolio');
        }
    },
    description: {
        list() {
            return axios.get('home/descriptions');
        }
    }
}